import devConfig from './config.dev';
import prodConfig from './config.prod';

export enum AppType {
  FXM = 'FXM',
}

interface Config {
  appType: AppType;
  contextPath: string;
  url: (subUrl: string) => string;
  servers: {
    gateway: {
      enabled: boolean;
      url: string;
    };
    policy: {
      enabled: boolean;
      url: string;
    };
    fsp: {
      enabled: boolean;
      url: string;
    };
    infra: {
      enabled: boolean;
      url: string;
    };
    fidp: {
      enabled: boolean;
      url: string;
    };
    log: {
      enabled: boolean;
      version: string;
      periodDays: number;
      url: string;
      urlDownload: string;
    };
    auth: {
      enabled: boolean;
      url: string;
    };
    pki: {
      enabled: boolean;
      url: string;
    };
    fxm: {
      enabled: boolean;
      url: string;
    };
    issuance: {
      enabled: boolean;
      url: string;
    };
    config: {
      enabled: boolean;
      url: string;
    };
    fdrledger: {
      enabled: boolean;
      url: string;
    };
  };
}

const appType = AppType.FXM;

const config: Config = import.meta.env.PROD
  ? {
      ...prodConfig,
      appType,
    }
  : {
      ...devConfig,
      appType,
    };
export default config;
